'use strict';

var base = require('base/contactUs/contactUs');

/**
 * Gets a field validation message from field data attributes or browser validation.
 * @param {HTMLElement} field - form field to validate
 * @returns {string} validation message
 */
function getFieldValidationMessage(field) {
    var $field = $(field);

    if (field.validity.valueMissing && $field.data('missing-error')) {
        return $field.data('missing-error');
    }

    if (field.validity.typeMismatch && field.type === 'email' && $field.data('email-error')) {
        return $field.data('email-error');
    }

    return field.validationMessage;
}

/**
 * Marks a field as invalid and writes the visible error text.
 * @param {HTMLElement} field - invalid field
 */
function showFieldError(field) {
    var $field = $(field);
    var message = getFieldValidationMessage(field);

    $field.addClass('is-invalid').attr('aria-invalid', 'true');
    $field.parents('.form-group').find('.invalid-feedback').text(message);
}

/**
 * Validates the Contact Us form and moves focus to the first invalid field.
 * @param {JQuery} $form - contact us form
 * @returns {boolean} whether form is valid
 */
function validateContactUsForm($form) {
    var firstInvalidField = null;

    $form.find('input:visible, select:visible, textarea:visible').each(function () {
        if (this.checkValidity && !this.checkValidity()) {
            showFieldError(this);
            firstInvalidField = firstInvalidField || this;
        }
    });

    if (firstInvalidField) {
        $('html, body').animate({
            scrollTop: $(firstInvalidField).parents('.form-group').offset().top - 150
        }, 500);

        firstInvalidField.focus();
        return false;
    }

    return true;
}

/**
 * Display the returned message.
 * @param {Object} data - data returned from the server's ajax call
 * @param {JQuery} form - submitted Contact Us form
 */
function displayMessage(data, form) {
    let $contactUsForm = form;
    let $contactUsMessageWrapper = $contactUsForm.closest('.contact-us-message-form');
    let $contactUsSignupMessage = $contactUsMessageWrapper.find('.contact-us-signup-message');
    let $contactUsStatus = $contactUsMessageWrapper.find('.contact-us-status');
    var feedbackText = data.success
        ? $contactUsStatus.attr('data-success-message')
        : $('<div>').html(data.msg || '').text();

    $.spinner().stop();
    $contactUsSignupMessage.find('.response-wrapper').empty();

    if (data.success) {
        $contactUsSignupMessage.addClass('d-flex').find('.response-wrapper').append(data.msg);
    } else {
        $contactUsSignupMessage.addClass('d-flex').find('.response-wrapper').append('<div class="contact-us-signup-alert text-center alert-danger" role="alert">' + data.msg + '</div>');
    }

    $('html, body').animate({
        scrollTop: $contactUsMessageWrapper.offset().top - 200
    }, 500);

    $contactUsForm.addClass('d-none');
    $contactUsStatus.text(feedbackText);
    $contactUsSignupMessage.find('.contact-us-signup-message-close').focus();
}

/**
 * Hide thank you message
 * @param {jQuery} button - close button element
 */
function closeMessage(button) {
    let $contactUsMessageWrapper = button.closest('.contact-us-message-form');
    let $contactUsSignupMessage = $contactUsMessageWrapper.find('.contact-us-signup-message');
    let $contactUsForm = $contactUsMessageWrapper.find('form.contact-us');
    var submitButton = $contactUsForm.find('.subscribe-contact-us');

    $contactUsSignupMessage.removeClass('d-flex').find('.response-wrapper').empty();
    $contactUsMessageWrapper.find('.contact-us-status').empty();
    $contactUsForm.removeClass('d-none');
    submitButton.removeAttr('disabled');
    $contactUsForm.find(':input:visible').first().focus();
}

/**
 * Submits the conatct form to the ContactUs-Subscribe route
 * @param {JQuery} form - the contactUs form as a jQuery object
 * @param {string} url - the ContactUs-Subscribe route's url
 * @param {JQuery} button - the button as a jQuery object
 */
function contactUs(form, url) {
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            displayMessage(data, form);
            if (data.success) {
                form.trigger('reset');
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                displayMessage(err, form);
            }
        }
    });
}

module.exports = $.extend(base, {
    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var button = form.find('.subscribe-contact-us');
            var url = form.attr('action');

            if (!validateContactUsForm(form)) {
                return;
            }

            $.spinner().start();
            button.attr('disabled', true);
            var $recaptcha = $(this).find('[name="g-recaptcha-response"]');
            if ($recaptcha.length) {
                var siteKey = $recaptcha.data('sitekey');
                var action = form.find('[name="g-recaptcha-action"]').val();
                var recaptchExecCB = function (token) { // eslint-disable-line
                    $recaptcha.val(token);
                    contactUs(form, url);
                };
                if (grecaptcha.enterprise) { // eslint-disable-line
                    grecaptcha.enterprise.ready(function () { // eslint-disable-line
                        grecaptcha.enterprise.execute(siteKey, { action: action }).then(recaptchExecCB); // eslint-disable-line
                    });
                } else {
                    grecaptcha.ready(function () { // eslint-disable-line
                        grecaptcha.execute(siteKey, { action: action }).then(recaptchExecCB); // eslint-disable-line
                    });
                }
            } else {
                contactUs(form, url);
            }
        });

        $('body').on('click', '.contact-us-signup-message-close', function () {
            closeMessage($(this));
        });

        $('form.contact-us').on('change input', ':input, .form-control', function () {
            if ($(this).hasClass('is-invalid')) {
                $(this).removeClass('is-invalid').removeAttr('aria-invalid');
                $(this).parents('.form-group').find('.invalid-feedback').empty();
            }
        });
    }
});
